/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// react-countup components
import CountUp from "react-countup";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";
import SoftTypography from "components/SoftComponents/SoftTypography";
import { getHealthStatus } from "utils/device";

function HealthStatusCard({ statistics, variant = "d3", showAdvancedDeviceLevel, transparent = false }) {
    var health = getHealthStatus(statistics, showAdvancedDeviceLevel);

    const content = (
        <SoftBox p={2} textAlign="center" display="flex" flexDirection="column" lineHeight={1.25}>
            <SoftTypography variant={variant} color={health.color} fontWeight="bold" textTransform="capitalize" textGradient>
                {health.text}
            </SoftTypography>
            <SoftTypography
                pt={1}
                variant="caption"
                fontWeight="medium"
                textTransform="capitalize"
                fontSize="18px"
                textGradient
            >
                Health Status
            </SoftTypography>
        </SoftBox>
    );

    if (transparent) {
        return content;
    }
    else {
        return (
            <Card>
                {content}
            </Card>
        );
    }
}

// Typechecking props for the BlogCard
HealthStatusCard.propTypes = {
    statistics: PropTypes.object,
    variant: PropTypes.string,
    showAdvancedDeviceLevel: PropTypes.bool,
    transparent: PropTypes.bool,
};

export default HealthStatusCard;
